<style lang="less" scoped>
.img-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(123, 122, 122, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  .img {
    width: 950px;
    height: 500px;
    position: relative;
    .img-content {
      width: 950px;
      height: 500px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .btn {
      position: absolute;
      top: -50px;
      right: -50px;
      width: 50px;
      height: 50px;
    }
    .btn:hover {
      cursor: pointer;
    }
    img {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
<template>
  <div class="img-box">
    <div class="img">
      <div class="img-content">
        <img :src="img" alt />
      </div>
      <div class="btn" @click="closeVideo">
        <img src="@/assets/images/icon/close_video.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: "",
    },
    showImg: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeVideo() {
      this.$emit("closeImg", false);
    },
  },
};
</script>
